import { makeStyles } from "@material-ui/core/styles";
import BarChartIcon from "@material-ui/icons/BarChart";
import BusinessIcon from "@material-ui/icons/Business";
import GroupIcon from "@material-ui/icons/Group";
import MessageIcon from "@material-ui/icons/Message";
import ScheduleIcon from "@material-ui/icons/Schedule";
import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";

import CompaniesImage from "@assets/img/companies.svg";
import LogoImage from "@assets/img/logo.svg";
import SideMenu from "@components/SideMenu";
import SideMenuItemLink from "@components/SideMenuItemLink";
import SideMenuItemMenu from "@components/SideMenuItemMenu";
import { joinClasses } from "@utils/materialUI";

const useStyles = makeStyles(() => ({
  menu: {},
  menuMain: {
    position: "fixed",
    top: "0px",
    left: "0px",
    width: "260px",
    height: "100%",
    paddingTop: "64px",
    paddingBottom: "56px",
    boxSizing: "border-box",
    backgroundImage: "linear-gradient(180deg, #432554 50%, #322234 100%)",
    zIndex: 999,
    transform: "translateX(-100%)",
    transition: "transform 0.2s ease",
    "@media all and (min-width: 1024px)": {
      transform: "translateX(0%)",
      boxShadow: "none",
    },
  },
  menuMainActive: {
    transform: "translateX(0%)",
    boxShadow: "2px 0px 7px 0px rgb(0 0 0 / 20%);",
  },
  menuMainContent: {
    width: "100%",
    height: "100%",
    overflowY: "auto",
  },
  menuMainLogo: {
    position: "absolute",
    top: "0px",
    left: "0px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "64px",
    padding: "0 20px",
    cursor: "pointer",
    boxSizing: "border-box",
  },
  menuMainLogoImage: {
    display: "block",
    maxWidth: "100%",
    width: "164px",
  },
  menuMainCompany: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    bottom: "0px",
    left: "0px",
    width: "100%",
    height: "56px",
    padding: "0 32px",
    boxSizing: "border-box",
  },
  menuMainCompanyImage: {
    display: "block",
    maxWidth: "100%",
    width: "140px",
  },
  menuShadow: {
    position: "fixed",
    top: "0px",
    left: "0px",
    width: "100%",
    height: "100%",
    background: "rgba(0, 0, 0, 0.2)",
    zIndex: 998,
    transform: "translateX(-100%)",
    "@media all and (min-width: 1024px)": {
      display: "none",
    },
  },
  menuShadowActive: {
    transform: "translateX(0%)",
    "@media all and (min-width: 1024px)": {
      transform: "translateX(-100%)",
    },
  },
}));

function AdminHeaderMenu(props) {
  const classes = useStyles();

  function handleInactiveMenu() {
    props.onInactiveMenu();
  }

  return (
    <div className={classes.menu}>
      <div
        className={joinClasses(classes.menuMain, {
          [classes.menuMainActive]: props.activeMenu,
        })}
      >
        {/* logo */}
        <Link to="/" className={classes.menuMainLogo}>
          <img
            src={LogoImage}
            alt="Torpedo Empresa"
            className={classes.menuMainLogoImage}
          />
        </Link>
        {/* end logo */}
        <div className={classes.menuMainContent}>
          {/* menu */}
          <SideMenu>
            <SideMenuItemLink
              label="Empresa"
              to="/empresa"
              icon={BusinessIcon}
            />
            <SideMenuItemLink
              label="Mensagem"
              to="/mensagem"
              icon={MessageIcon}
            />
            <SideMenuItemLink
              label="Agendamentos"
              to="/agendamentos"
              icon={ScheduleIcon}
            />
            <SideMenuItemLink label="Grupos" to="/grupos" icon={GroupIcon} />
            <SideMenuItemMenu label="Relatórios" icon={BarChartIcon}>
              <SideMenuItemLink
                label="Caixa de Saída"
                to="/relatorios/caixa-de-saida"
              />
              <SideMenuItemLink
                label="Caixa de Entrada"
                to="/relatorios/caixa-de-entrada"
              />
              <SideMenuItemLink
                label="Mensagens Enviadas"
                to="/relatorios/mensagens-enviadas"
              />
              {/*
              <SideMenuItemLink
                label="Mensagens Recebidas"
                to="/relatorios/mensagens-recebidas"
              />
              */}
              <SideMenuItemLink
                label="SMS - MO e DR"
                to="/relatorios/sms-mo-dr"
              />
            </SideMenuItemMenu>
          </SideMenu>
        </div>
        {/* company */}
        <div className={classes.menuMainCompany}>
          <img
            className={classes.menuMainCompanyImage}
            src={CompaniesImage}
            alt="Telefônica | Vivo"
          />
        </div>
        {/* end company */}
      </div>
      <div
        className={joinClasses(classes.menuShadow, {
          [classes.menuShadowActive]: props.activeMenu,
        })}
        onClick={handleInactiveMenu}
      ></div>
    </div>
  );
}

AdminHeaderMenu.propTypes = {
  activeMenu: PropTypes.bool,
  onInactiveMenu: PropTypes.func,
};

AdminHeaderMenu.defaultProps = {
  activeMenu: false,
  onInactiveMenu: () => {},
};

export default AdminHeaderMenu;
